/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZohoServiceDeskAlertMapping {
    getFixupPrototypeFunction() { return ZohoServiceDeskAlertMapping.fixupPrototype; }

    static newInstance(model: Partial<ZohoServiceDeskAlertMapping>): ZohoServiceDeskAlertMapping {
        let obj = Object.assign(new ZohoServiceDeskAlertMapping(), model);
        ZohoServiceDeskAlertMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZohoServiceDeskAlertMapping>): ZohoServiceDeskAlertMapping {
        if (!model) return null;
        return ZohoServiceDeskAlertMapping.newInstance(<ZohoServiceDeskAlertMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZohoServiceDeskAlertMapping) {
        if (!obj) return;

        models.ZohoServiceDeskAlertMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZohoServiceDeskAlertMapping): boolean {
        Object.setPrototypeOf(obj, ZohoServiceDeskAlertMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    selected_description_attributes: Array<models.ZohoServiceDeskAlertDescriptionAttribute>;

    selected_incident_attributes: Array<models.ZohoServiceDeskAlertIncidentAttribute>;

}
